import Type from 'modules/Recommendations/CampaignsRecommendations/Type/Type'
import Reducer from 'modules/Recommendations/CampaignsRecommendations/Type/store/reducer'
import Sagas from 'modules/Recommendations/CampaignsRecommendations/Type/store/saga'

export default Type

export { Sagas, Reducer }
